var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTasksIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2C10.843 1.99999 10.6882 2.03696 10.5481 2.1079C10.408 2.17885 10.2866 2.28178 10.1937 2.40837C10.1008 2.53496 10.0391 2.68164 10.0134 2.83654C9.98772 2.99145 9.99889 3.15022 10.046 3.3L10.266 4H7C6.73478 4 6.48043 4.10536 6.29289 4.2929C6.10536 4.48043 6 4.73479 6 5V29C6 29.2652 6.10536 29.5196 6.29289 29.7071C6.48043 29.8946 6.73478 30 7 30H25C25.2652 30 25.5196 29.8946 25.7071 29.7071C25.8946 29.5196 26 29.2652 26 29V5C26 4.73479 25.8946 4.48043 25.7071 4.2929C25.5196 4.10536 25.2652 4 25 4H21.736L21.956 3.3C22.0032 3.15006 22.0143 2.99111 21.9885 2.83605C21.9628 2.68099 21.9008 2.53419 21.8077 2.40756C21.7146 2.28093 21.5929 2.17804 21.4526 2.10722C21.3122 2.03641 21.1572 1.99968 21 2H11ZM12.36 4H19.64L19.014 6H12.986L12.36 4ZM22 14H10V12H22V14ZM22 19H10V17H22V19ZM10 24H18V22H10V24Z",
    fill: "#091540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksIcon);
export default __webpack_public_path__ + "static/media/tasks-icon.40b15bb0a6adf645c7f6d57f350ffe6e.svg";
export { ForwardRef as ReactComponent };